// Create a global AudioContext, but it will need a user gesture to resume
const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
let isPlaying = false // Track if audio is currently playing
let audioBufferQueue = [] // Queue to handle audio chunks

/**
 * Decodes and plays a Base64-encoded audio chunk via the Web Audio API.
 */
const playAudioQueue = () => {
  if (isPlaying || audioBufferQueue.length === 0) return

  isPlaying = true
  const audioBuffer = audioBufferQueue.shift()

  const source = audioCtx.createBufferSource()
  source.buffer = audioBuffer
  source.connect(audioCtx.destination)

  source.onended = () => {
    isPlaying = false
    playAudioQueue() // Play the next chunk in the queue
  }

  source.start()
}

const playChunkViaAudioContext = async base64Chunk => {
  try {
    // Convert Base64 to ArrayBuffer
    const binaryStr = atob(base64Chunk)
    const buffer = new Uint8Array(binaryStr.length)
    for (let i = 0; i < binaryStr.length; i++) {
      buffer[i] = binaryStr.charCodeAt(i)
    }

    // console.log('Decoded Uint8Array buffer size:', buffer.byteLength)

    // Skip empty buffers
    if (!buffer || buffer.byteLength === 0) {
      console.error('Received empty or invalid audio buffer')
      return
    }

    // Decode audio data
    const audioBuffer = await audioCtx.decodeAudioData(buffer.buffer)
    audioBufferQueue.push(audioBuffer)
    playAudioQueue()
  } catch (err) {
    console.error(
      'Error decoding audio chunk:',
      err.message,
      base64Chunk.slice(0, 50)
    )
  }
}

module.exports = { playChunkViaAudioContext }